import { Button, ConfigProvider, Layout, Row, Space, Spin, Tabs } from "antd";
import { Content, Footer } from "antd/es/layout/layout";
import { useTranslation } from "react-i18next";
import WorkFlowList from "./WorkFlowList";
import { setCurrentFlow } from "../slices/workFlowSlice";
import { useDispatch, useSelector } from "react-redux";



const WorkFlowComponent = ({
    chainOfCommand = () => { },
    approveByRole = () => { },
    approveByPosition = () => { },
    requester = () => { },
    handleAddComponent = () => { },
    PlusDropdown = () => { },
    reset = () => { },
    onDelete = () => { },
    addNewWorkFlow = () => { },
    RenderNewWorkFlow = () => { },
    RenderCellTwo = () => { },
    stepOfNumber = () => { },
    list = [],
    listworkflow = [],
    setList = () => { },
    RenderCell = () => { },
    onSave = () => { }
}) => {
    const { t, i18n } = useTranslation();
    const dispatch = useDispatch();
    const isLoading = useSelector((state) => state.workFlow.isLoading);
    const isLoading2 = useSelector((state) => state.holidayCalendar.isLoading);

    // ENDORSE_TIME
    // OFFSITE_WORK
    // OVER_TIME
    // COLLECT_TIME
    // DOC_REQUEST
    // TIME_ADJUSTMENT
    const itemList = [
        {
            label: t("leave-work"),
            key: "Leave",
            children: <WorkFlowList type={"LEAVE"} />,
        },
        {
            label: t("offsite-work"),
            key: "OFFSITE_WORK",
            children: <WorkFlowList type={"OFFSITE_WORK"} />,
        },
        {
            label: t("endorse-time"),
            key: "ENDORSE_TIME",
            children: <WorkFlowList type={"ENDORSE_TIME"} />,
        }
        ,
        {
            label: t("overtime.header"),
            key: "OVER_TIME",
            children: <WorkFlowList type={"OVER_TIME"} />,
        }
        ,
        {
            label: t("collect-time"),
            key: "COLLECT_TIME",
            children: <WorkFlowList type={"COLLECT_TIME"} />,
        }
        ,
        {
            label: t("document_request.header"),
            key: "DOC_REQUEST",
            children: <WorkFlowList type={"DOC_REQUEST"} />,
        }
        ,
        {
            label: t("time_adjustment"),
            key: "TIME_ADJUSTMENT",
            children: <WorkFlowList type={"TIME_ADJUSTMENT"} />,
        },
        {
            label: t("movement.header"),
            key: "MOVEMENT",
            children: <WorkFlowList type={"MOVEMENT"} />,
        },
        {
            label: t("changeshift.label.changeshift"),
            key: "CHANGE_SHIFT",
            children: <WorkFlowList type={"CHANGESHIFT"} />,
        },
        {
            label: t("warning_letter.entity"),
            key: "WARNING_LETTER",
            children: <WorkFlowList type={"WARNINGLETTER"} />,
        },
        {
            label: t("expense.header"),
            key: "EXPENSES",
            children: <WorkFlowList type={"EXPENSES"} />,
        }

    ]


    return (
        <Layout style={{
            width: "100%",
        }}>
            <Spin spinning={isLoading || isLoading2} >

                <Content style={{
                    width: "100%",
                    // paddingRight: ""17vw
                }}>
                    <ConfigProvider
                        theme={{
                            components: {
                                Tabs: {
                                    cardBg: "#EFF2F5",
                                },
                            },
                        }}
                    >
                        <Tabs

                            onTabClick={() => {
                                dispatch(setCurrentFlow('MAIN_FLOW'))
                            }}
                            type="card"
                            destroyInactiveTabPane={true}
                            items={itemList}
                        />
                    </ConfigProvider>
                </Content>
            </Spin>

        </Layout>

    );
};

export default WorkFlowComponent;
